import { required, optional, obj, array } from 'AppReact/schema';
import { event } from './event';
import { file } from './orderEvent';

export const witness = {
    name: required('string'),
    phone: required('string')
}


export const fullIncidentReport = {
    id: required('integer'),
    property_id: required('integer'),
    property_name: required('string'),
    submitted_by: required('string'),
    submitted_at: required('jsDate'),
    request_id: required('integer'),
    tech_id: optional('integer'),
    tech_name: optional('string'),
    tech_image: optional('string'),
    tech_phone: optional('string'),
    tech_email: optional('string'),
    incident_type_id: required('integer'),
    attachments: array(obj(file)),
    reportings: array(obj({
        id: required('integer'),
        person_id: required('integer'),
        name: required('string'),
        email: optional('string'),
        icon_url: optional('string'),
        datetime: optional('jsDate'),
        phone: optional('string'),
    })),
    incident_datetime: required('jsDate'),
    report_datetime: required('jsDate'),
    description: required('string'),
    location: optional('string'),
    emergency_services_called: optional('boolean'),
    reported_by: required('string'),
    witnesses: array(obj(witness)),
    actions: optional('string'),
    in_occupied_unit: optional('string'),
    unit_number: optional('string'),
    unit_id: optional('integer'),
    renters_claim_filed: optional('string'),
    notification_method: optional('string'),
    notifier: optional('string'),
    surveillance_footage_available: optional('string'),
    involved_residents: array(obj({
        email: optional('string'),
        id: required('integer'),
        name: required('string'),
        phone: optional('string')
    })),
    events: array(obj(event))
}